import React from 'react';
import { motion } from 'framer-motion';
import { Thermometer, Droplets, Zap } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: Thermometer,
    title: 'Layer 1 — Temperature',
    desc: "If your internal thermostat is unstable, your body acts like something is wrong. It nudges you awake to 'fix it.'"
  }, {
    icon: Droplets,
    title: 'Layer 2 — Blood Sugar Stability',
    desc: "If your body senses low fuel or instability overnight, it can push stress hormones. That 'wide awake' feeling can be chemistry, not character."
  }, {
    icon: Zap,
    title: 'Layer 3 — Nervous System',
    desc: "Once you're awake, your mind searches for a reason. That's when you spiral. Most people start here. That's why it fails."
  }];
  return <section className="py-20 bg-[#FAF8F5]" data-id="element-203">
      <div className="max-w-5xl mx-auto px-4" data-id="element-204">
        <div className="text-center mb-16" data-id="element-205">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-206">
            <h2 className="text-3xl md:text-5xl font-bold mb-6 text-[#2C2C2C]" data-id="element-207">
              The 3-Layer Night Loop
            </h2>
            <p className="text-xl text-[#4A4A4A] max-w-2xl mx-auto" data-id="element-208">
              You interrupt menopause sleep disruption in the only order that
              sticks.
            </p>
          </motion.div>
        </div>

        <div className="relative" data-id="element-209">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-[#E5E0D8] -translate-x-1/2" data-id="element-210" />

          <div className="space-y-12 md:space-y-24" data-id="element-211">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className={`flex flex-col md:flex-row items-center gap-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-212">
                <div className="flex-1 text-center md:text-left" data-id="element-213">
                  <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#FC8EAC]/10 text-[#FC8EAC] mb-4 md:mb-0 md:hidden`} data-id="element-214">
                    <step.icon className="w-8 h-8" data-id="element-215" />
                  </div>
                  <h3 className="text-2xl font-bold mb-3 text-[#2C2C2C]" data-id="element-216">
                    {step.title}
                  </h3>
                  <p className="text-lg text-[#4A4A4A] leading-relaxed" data-id="element-217">
                    {step.desc}
                  </p>
                </div>

                <div className="relative z-10 flex items-center justify-center w-16 h-16 rounded-full bg-[#FC8EAC] text-white shadow-lg border-4 border-[#FAF8F5] hidden md:flex" data-id="element-218">
                  <step.icon className="w-8 h-8" data-id="element-219" />
                </div>

                <div className="flex-1 hidden md:block" data-id="element-220" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}